<template>
    <el-dialog class="dialog" :visible="dialogs.skillRename" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Переименуйте {{ typeSkill }}</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form
                action="#"
                class="dialog__form"
                @submit.prevent="typeSkill === 'Hard Skill' ?
                    create ? createHardSkill($event) : renameHardSkill($event)
                    : renameSoftSkill($event)"
                autocomplete="off"
            >
                <div class="dialog__content">
                    <input type="text" name="name" class="input" v-model="newSkillName" required>
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item">
                            <span class="c-primary">Пример наименования: Разрабатывать концептуальную платежную систему</span>
                        </div>
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action">
                                Применить
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    props: {
        typeSkill: {
            required: true,
            type: String  
        },
        curItem: {
            type: Object,
            default: function() {
                return {}
            }
        },
        create: {
            type: Boolean,
            default: false
        },
        skillName: {
            required: true,
            type: String
        },
        qualificationId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            newSkillName: null
        }
    },
    methods: {
        ...mapActions('editor', [
            'CREATE_HARD_SKILL',
            'UPDATE_HARD_SKILLS_BY_QUALIFICATION',
            'UPDATE_SOFT_SKILL_BY_QUALIFICATION',
            'UPDATE_HARD_SKILL_BY_QUALIFICATION'
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),

        closeDialog() {
            this.elDialogs.skillRename = false;
        },
        async createHardSkill(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                qualification_id: this.qualificationId
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            const hardSkill = await this.CREATE_HARD_SKILL(params);

            const ids = [hardSkill.id, ...this.hardSkillsByQualification.map((item) => item.id)];

            await this.UPDATE_HARD_SKILLS_BY_QUALIFICATION({
                id: this.qualificationId,
                ids
            });

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { hard_skills: this.hardSkillsByQualification.length }) : qualification))
            await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.closeDialog();
        },
        renameHardSkill(e) {
            const formData = new FormData(e.target);

            const params = JSON.parse(JSON.stringify(this.curItem))

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.UPDATE_HARD_SKILL_BY_QUALIFICATION(params)
            
            this.closeDialog();
        },
        renameSoftSkill(e) {
            const formData = new FormData(e.target);

            const params = this.curItem

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.UPDATE_SOFT_SKILL_BY_QUALIFICATION(params)

            this.closeDialog();
        },
        handleOpen() {
            this.$nextTick(() => {
                this.newSkillName = this.skillName;
            });
        }
    },
    computed: {
        ...mapState('editor', ['hardSkillsByQualification', 'qualifications', 'groupItemsBy']),
    },
    mounted() {
        this.newSkillName = this.skillName;
    }
}
</script>
